/**
 * Check if a specified storage functionality is avilable.
 *
 * @param {String} type The storage type to check for, e.g. localStorage, sessionStorage or cookies.
 * @returns {Boolean} Whether the storage type is available or not.
 */
function isStorageAvailable(type) {
  var storage, testItem
  try {
    storage = window[type]
    testItem = '__storage_test__'
    storage.setItem(testItem, testItem)
    storage.removeItem(testItem)
    return true
  } catch (ignore) {
    return false
  }
}

export default isStorageAvailable
